import React from "react";
import SVGMorph from "../SVGMorph";
import { lunges1, lunges2, lunges3 } from "./path";

function Lunges() {
  return (
    <svg
      style={{ width: "clamp(18.75rem, 16.8739rem + 9.3805vw, 32rem)" }}
      viewBox="0 0 411 647"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SVGMorph paths={[lunges1, lunges2, lunges2, lunges1]} />
    </svg>
  );
}

export default Lunges;
